import React from 'react'
import PropTypes from 'prop-types'
import { reduxForm, Field } from 'redux-form'
import Form from '../common/Form'
import Divider from '../common/Divider'
import InputContainer from '../../containers/common/InputContainer'
import Button from '../common/Button'
import CancelButton from '../common/CancelButton'
import FormError from '../common/FormError'
import { updateAccountPasswordAction } from '../../actions/accountActions'
import { required, maxLength, minLength } from '../../utils/validators'

const maxLength30 = maxLength(30)
const minLength6 = minLength(6)

const EditAccountPasswordForm = props => {
  const { handleSubmit, submitting, error } = props

  const submit = handleSubmit(updateAccountPasswordAction)

  return (
    <section className="EditAccountPasswordForm">
      <Form onSubmit={submit}>
        <Divider />
        <div className="flex-ns">
          <Field
            name="oldPassword"
            type="password"
            component={InputContainer}
            label="Current Password"
            validate={[required]}
            className="w-50-ns mr3-ns"
          />
          <Field
            name="newPassword"
            type="password"
            component={InputContainer}
            label="New Password"
            validate={[required, minLength6, maxLength30]}
            className="w-50-ns"
          />
        </div>
        <Divider />
        <FormError error={error} />
        <div className="flex justify-between">
          <CancelButton defaultLocation="/account/profile" />
          <Button text="Submit" type="submit" submitting={submitting} />
        </div>
      </Form>
    </section>
  )
}

EditAccountPasswordForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  error: PropTypes.string,
}

export default reduxForm({ form: 'EditAccountPasswordForm' })(
  EditAccountPasswordForm
)
